"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _redirectIfLoggedOut["default"];
  }
});
var _redirectIfLoggedOut = _interopRequireDefault(require("./redirectIfLoggedOut"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }